import { NotificationType } from '../../../../aumico-lib-users-fe/src/lib/enums/notification-type.enum';
import { IUserNotificationData } from './user-notification-data.interface';
export interface NotificationSocketPayloadDto {
    id: string;
    userId: string;
    organizationId: string;
    dataCenter: string;
    type: NotificationType;
    isRead: boolean;
    isArchived: boolean;
    data: IUserNotificationData;
    createdAt: Date;
    updatedAt: Date;
}
